import { Box, Popover } from "@mantine/core";
import type { ReactNode } from "react";

export default function ExperimentChatPopover({ children, opened = false }: { children: ReactNode; opened?: boolean }) {
  return (
    <Box pos="relative" top={20} right={15}>
      <Popover
        opened={opened}
        position="bottom"
        radius="lg"
        offset={-50}
        transitionProps={{ transition: "pop-top-right" }}
        middlewares={{ shift: { padding: 15 }, flip: { crossAxis: true } }}
        zIndex={200} // Make the Popover appear below modals.
        overlayProps={{ zIndex: 250 }}
        withinPortal={false}
      >
        <Popover.Target>
          <Box pos="relative" top={20} right={15} />
        </Popover.Target>
        <Popover.Dropdown px={5} pt="xs" pb={7}>
          <Box h="85vh" mih={500} w="30vw" miw={300}>
            {children}
          </Box>
        </Popover.Dropdown>
      </Popover>
    </Box>
  );
}
